import React from 'react';
import { CtaBlock } from './CtaBlock';
import { AUTHOR_IMAGE } from '../data/content';
const paragraphs = ['Weil die meisten Menschen beim Schweißen nicht scheitern, weil ihnen die Fähigkeit fehlt.', 'Sie haben Schwierigkeiten, weil ihnen niemand klar erklärt, was sie tun sollten, bevor sie die Maschine einschalten.', 'Sie lernen durch Videos, die sich manchmal widersprechen. Sie verschwenden Material mit unnötigen Versuchen.', 'Und irgendwann glauben sie, dass Schweißen viel schwieriger ist, als es tatsächlich sein müsste.'];
export function Author() {
  return <section className="border-t border-ink-700 bg-ink-900 px-4 py-12 sm:px-6 sm:py-16" data-id="element-19" data-mp="sjn4q38lx0y2">
      <div className="mx-auto w-full max-w-4xl" data-id="element-20" data-mp="xihmd1uu8jgl">
        <div className="grid gap-6 md:grid-cols-[minmax(0,300px)_minmax(0,1fr)] md:items-start md:gap-8" data-id="element-21" data-mp="xh6hsztkj7of">
          <div data-id="element-22" data-mp="3d82h7evfcseb">
            <img src={AUTHOR_IMAGE} alt="Markus Brandt, Schweißmeister und Autor des Meister-Schweißsystems" className="w-full rounded-2xl border border-ink-700 object-cover" width={800} height={1000} loading="lazy" data-id="element-23" data-mp="3d8ax7fmugdtq" />
            <div className="mt-3 text-center md:text-left" data-id="element-24" data-mp="1p1tv2v8gw5nx">
              <p className="font-display text-xl uppercase leading-tight text-white" data-id="element-25" data-mp="2301kmi36c4p2">
                Markus Brandt
              </p>
              <p className="mt-1 text-sm text-white/60" data-id="element-26" data-mp="1y2i7xmm4jzz8">
                Schweißmeister · 22 Jahre Werkstattpraxis · Autor des Systems
              </p>
            </div>
          </div>

          <div data-id="element-27" data-mp="27y36tbvwck4r">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand" data-id="element-28" data-mp="27wiiw5437zfv">
              Unsere Mission
            </p>
            <h2 className="mt-2 font-display text-[24px] uppercase leading-tight text-white sm:text-3xl" data-id="element-29" data-mp="2hnwei1sx4f3q">
              Warum haben wir das Meister-Schweisssystem™ entwickelt?
            </h2>
            <div className="mt-4 space-y-3" data-id="element-30" data-mp="2qpcpaannaj8h">
              {paragraphs.map(paragraph => <p key={paragraph} className="text-[15px] leading-relaxed text-white/70" data-id="element-31" data-mp="1obye7rvceky5">
                  {paragraph}
                </p>)}
            </div>

            <div className="mt-5 rounded-xl border-l-2 border-brand bg-ink-800 p-4" data-id="element-32" data-mp="1sanld2psf69c">
              <p className="text-[15px] leading-relaxed text-white" data-id="element-33" data-mp="1xa08zpohghcz">
                Das MEISTER-SCHWEISSSYSTEM™ wurde entwickelt, um das zu verändern. Es ist nicht
                einfach ein weiterer Kurs voller Theorie – es ist ein praktisches Nachschlagewerk,
                das dir hilft, klarer zu wissen, was du tun und überprüfen solltest, wenn du
                schweißen möchtest.
              </p>
            </div>
          </div>
        </div>

        <CtaBlock label="Ich will das Nachschlagewerk" showTimer={false} note="Sofortiger Zugang · Lebenslanger Zugang" className="mt-8" data-id="element-34" data-mp="2l0mhfi2eg3ni" />
      </div>
    </section>;
}